const emailTypes = {
  BOOK: 'book',
  CONTACT: 'contact',
  DOWNLOADLINK: 'download links',
  ARTICLE: 'article',
} as const;

export default emailTypes;
